import Button from 'components/Button';
import {FC, HTMLAttributes, ReactNode} from 'react';
import {ErrorBoundary, useErrorBoundary} from 'react-error-boundary';
import {t} from 'ttag';

type Props = HTMLAttributes<HTMLDivElement>;
const RenderErrorBoundary: FC<Props> = (props) => {
    const {resetBoundary} = useErrorBoundary();

    return (
        <div {...props}>
            <div className="flex flex-col items-center">
                <div>{t`We apologize, the UI encountered an error.`}</div>
                <Button
                    kind="secondary"
                    onClick={resetBoundary}
                >{t`Try again`}</Button>
            </div>
        </div>
    );
};
type ComponentErrorBoundaryProps = {
    children: ReactNode;
} & Props;
const ComponentErrorBoundary: FC<ComponentErrorBoundaryProps> = ({
    children,
    ...props
}) => {
    return (
        <ErrorBoundary fallback={<RenderErrorBoundary {...props} />}>
            {children}
        </ErrorBoundary>
    );
};
export default ComponentErrorBoundary;
